"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationTypes = void 0;
var LocationTypes;
(function (LocationTypes) {
    LocationTypes["SAVED"] = "Use my saved cart's location:";
    LocationTypes["CURRENT"] = "Use my current location:";
})(LocationTypes = exports.LocationTypes || (exports.LocationTypes = {}));
//# sourceMappingURL=RetrieveCartProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/cards/SaveRetrieveCart/RetrieveCart/RetrieveCartProps.js
// module id = 2279
// module chunks = 8